<sw-page class="topdata-es-search-stats-list-page">
    <template #smart-bar-header>
        <h2>{{ $tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.title') }}</h2>
    </template>

    <template #smart-bar-actions>
        <sw-button variant="primary" @click="onDownloadCsv">
            {{ $tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.buttonDownloadCsv') }}
        </sw-button>
        <sw-button variant="danger" @click="onReset">
            {{ $tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.buttonReset') }}
        </sw-button>
    </template>

    <template #content>
        <sw-entity-listing
            v-if="items"
            :dataSource="items"
            :columns="columns"
            :repository="repository"
            identifier="topdata-es-search-stats"
            detail-route="topdata.es.search.stats.detail"
            :show-settings="true"
            :show-selection="false"
            :allow-view="true"
            :allow-edit="false"
            :allow-delete="true"
            :allow-inline-edit="false"
            :full-page="true"
            :sort-by="sortBy"
            :sort-direction="sortDirection"
            :is-loading="isLoading"
            @page-change="onPageChange"
            @column-sort="onSortColumn"
        >
            <template #column-lastSearchedAt="{ item }">
                <sw-time-ago v-if="item.lastSearchedAt" :date="item.lastSearchedAt" />
            </template>

            <template #column-noiseReason="{ item }">
                <sw-label
                    v-if="item.isNoise"
                    variant="warning"
                    appearance="pill"
                >
                    {{ noiseReasonLabel(item.noiseReason) }}
                </sw-label>
                <template v-else>—</template>
            </template>

            <template #column-createdAt="{ item }">
                <sw-time-ago v-if="item.createdAt" :date="item.createdAt" />
            </template>
        </sw-entity-listing>

        <sw-modal
            v-if="showResetModal"
            :title="$tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.resetModalTitle')"
            variant="small"
            @modal-close="onCancelReset"
        >
            <p>{{ $tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.resetModalBody') }}</p>

            <template #modal-footer>
                <sw-button size="small" @click="onCancelReset">
                    {{ $tc('global.default.cancel') }}
                </sw-button>
                <sw-button variant="danger" size="small" @click="onConfirmReset">
                    {{ $tc('TopdataEnhancedSearchSW6.topdata-es-search-stats.resetModalConfirm') }}
                </sw-button>
            </template>
        </sw-modal>
    </template>
</sw-page>
